import { createContext, useContext } from "react";
import { TamaguiProvider } from "@tamagui/core";
import { PortalProvider } from "@tamagui/portal";
import { ToastProvider, ToastViewport } from "@tamagui/toast";
import config from "./tamagui.config";
import { jsx, jsxs } from "react/jsx-runtime";
const defaultAnalyticsContext = {
  useObservability: () => ({
    trackJourneyEvent: (_categoryName, _eventName, _eventData, _contextualData) => {
    }
  })
}, AnalyticsContext = createContext(defaultAnalyticsContext), useAnalyticsContext = () => useContext(AnalyticsContext);
function BricksProvider({
  children,
  useObservability,
  toastViewportProps,
  ...rest
}) {
  return useObservability = useObservability ?? defaultAnalyticsContext.useObservability, /* @__PURE__ */ jsx(
    AnalyticsContext.Provider,
    {
      value: {
        useObservability
      },
      children: /* @__PURE__ */ jsx(TamaguiProvider, { config, defaultTheme: "light", ...rest, children: /* @__PURE__ */ jsx(PortalProvider, { children: /* @__PURE__ */ jsxs(ToastProvider, { children: [
        children,
        /* @__PURE__ */ jsx(
          ToastViewport,
          {
            flexDirection: "column",
            top: 0,
            left: 0,
            right: 0,
            ...toastViewportProps
          }
        )
      ] }) }) })
    }
  );
}
export {
  AnalyticsContext,
  BricksProvider,
  defaultAnalyticsContext,
  useAnalyticsContext
};
